import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'passNumber'
})
/**
 * Takes a Error Message object and replaces  passnumber string with passenger number.
 * @example
 *
 * Input
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger { passNumber }."
 * }
 *
 * Output
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger 1."
 * }
 * @constructor
 * @param {Config} errorMessages - Error Message object.
 * @param {number} passengerIndex - Passenger index.
 */
export class PassengerNumberReplacePipe implements PipeTransform {
  transform(msg: string, passengerIndex: number): string {
    return msg.replace(/{ passNumber }/, (passengerIndex + 1).toString());
  }
}
